var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('abstract-manipulated-order-fields',{attrs:{"action_name":"show","manipulated_order_id":_vm.manipulated_order_id,"manipulated_order_sid":_vm.manipulated_order_sid,"button_label":""}})}
var staticRenderFns = []

export { render, staticRenderFns }